// Construit l'URL de la page publique (SEO) d'un jeu : /jeu/{slug}-{appId}.
// Le slug doit correspondre a celui genere cote backend (GamePageController.Slugify) ;
// en cas de petit ecart, le backend fait une redirection 301 vers l'URL canonique.
export const slugifyGame = (name) =>
  (name || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // retire les accents (marques combinantes)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const gameHref = (appId, name) => {
  const s = slugifyGame(name);
  return `/jeu/${s ? `${s}-${appId}` : appId}`;
};
